<section class="cards-list">
  <!-- sort bar -->
  <pwj-sorts-bar
    class="cards-list__filter-bar"
    [sorts]="listTabs"
    translateKey="sorting."
    sortParamKey="sort"
    [haveInitializeTab]="false"></pwj-sorts-bar>

  @if (products && !isLoading) {
    <div>
      @if (productsCount > 0 && products.length > 0) {
        <div>
          <!-- products list -->
          <div class="cards-list__products">
            <ul class="products-list">
              @for (product of products; track product._id) {
                <li>
                  <pwj-product-card
                    [productCardData]="product"></pwj-product-card>
                </li>
              }
            </ul>
          </div>

          <!-- pagination -->
          @if (productsCount) {
            <pwj-pagination
              [dataCount]="productsCount"
              [perPage]="12"></pwj-pagination>
          }
        </div>
      } @else {
        <div>
          <!-- no content component -->
          <pwj-no-content message="products.noProducts"></pwj-no-content>
        </div>
      }
    </div>
  } @else {
    <div>
      <!-- product card skeletons -->
      <pwj-product-card-skeleton
        [count]="12"
        containerClasses="flex flex-wrap gap-14 mt-46"></pwj-product-card-skeleton>
    </div>
  }
</section>
